import styled from 'styled-components';
import { getPaletteColor } from '../utils';
export const FixedCloseButton = /*#__PURE__*/styled.div.withConfig({
  displayName: "Popoverstyles__FixedCloseButton",
  componentId: "sc-awf553-0"
})(["position:fixed;top:4px;right:4px;"]);
export const StyledArrow = /*#__PURE__*/styled.div.withConfig({
  displayName: "Popoverstyles__StyledArrow",
  componentId: "sc-awf553-1"
})(["fill:", ";"], ({
  color
}) => getPaletteColor(color));